export const getTonesPayload = ( templateStyle, template, websiteDetails ) => {
  return {
    "promptId": "93da4c8a-631c-4c55-aec9-d8e8985d7f0a",
    "OpenAiChatOptions": {
        "functions": [
            {
                "name": "generate_tone_blocks",
                "description": "This function generates tailored text blocks in various tones for different sections of a website, each with specific content and token limits to ensure consistency in style and length across the website's textual elements.",
                "parameters": {
                    "type": "object",
                    "properties": {
                        "tones": {
                            "type": "object",
                            "description": "A collection of tone-based website text content.",
                            "properties": {
                                "neutral": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a neutral tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a neutral tone with a maximum of 4 tokens, providing direct and balanced language."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a neutral tone with a maximum of 10 tokens, presenting information clearly and concisely."
                                        }
                                    }
                                },
                                "persuasive": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a persuasive tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a persuasive tone with a maximum of 4 tokens, crafted to motivate clicks and interaction."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a persuasive tone with a maximum of 10 tokens, designed to convince and captivate the audience."
                                        }
                                    }
                                },
                                "friendly": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a friendly tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a friendly tone with a maximum of 4 tokens, inviting interaction in a casual and positive manner."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a friendly tone with a maximum of 10 tokens, fostering a welcoming and relatable message."
                                        }
                                    }
                                },
                                "formal": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a formal tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a formal tone with a maximum of 4 tokens, emphasizing sophistication and clarity."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a formal tone with a maximum of 10 tokens, maintaining a structured and respectful style."
                                        }
                                    }
                                },
                                "informative": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a informative tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in an informative tone with a maximum of 4 tokens, designed to guide users efficiently."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in an informative tone with a maximum of 10 tokens, prioritizing clarity and utility."
                                        }
                                    }
                                },
                                "professional": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a professional tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a professional tone with a maximum of 4 tokens, ensuring a polished and confident message."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a professional tone with a maximum of 10 tokens, projecting competence and reliability."
                                        }
                                    }
                                },
                                "thoughtful": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string",
                                            "description": "A creative and engaging cover title for the website written in a thoughtful tone, with a maximum of 3 words. This title should encapsulate the business's purpose or unique selling point."
                                        },
                                        "button1text": {
                                            "type": "string",
                                            "description": "Website button content written in a thoughtful tone with a maximum of 4 tokens, showing consideration and understanding."
                                        },
                                        "shortDescription": {
                                            "type": "string",
                                            "description": "Website description content written in a thoughtful tone with a maximum of 10 tokens, crafted to resonate with a mindful audience."
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        ],
        "functionCall": {
            "name": "generate_tone_blocks"
        },
        "Model": "gpt-4o-mini"
    },
    "metaData": {
            category: websiteDetails.data.category,
            businessName: websiteDetails.data.title,
            goal: websiteDetails.data.prompt
        }
    }
}

export const getTemplateCategoryPayload = ({ title, prompt, category }) => {
return {
            "promptId": "2fb62779-be31-49d1-a24c-faec5743cb8a",
            "OpenAiChatOptions": {
                "functions": [
                    {
                        "name": "template_selection",
                        "description": "This function selects the most appropriate style bucket along with other data points for a website based on the provided metadata.",
                        "parameters": {
                            "type": "object",
                            "properties": {
                                "category": {
                                    "type": "string",
                                    "description": "Most suitable category that matches customer's category and description from this list of categories: Restaurant, Services, Jewelry, Travel, Business, Biography, Music, Architect, Education, Antiques, Photographer, Crafts, Sports, Accessories, Accountant, Spa, Food, Beauty Products, Hair Products, Drinks, Electronics, Blog, Health, Events, Design, Hobby, Fashion, Art, Food Products, Auto Repair, Personal, Bakery, Beauty, Portfolio, Entertainment, Store, Fitness, Pet Grooming."
                                },
                                "photoCategory": {
                                    "type": "string",
                                    "description": "Always provide exactly two image tags (separated by commas) to find images on Unsplash that are most closely associated with and describe the metadata provided by the customer. Aim to use single-word tags whenever possible for clarity and relevance. If a multi-word phrase is necessary to preserve essential context (e.g., 'Ice Cream' or 'Food Truck'), include it. Ensure the total number of tags is always two, even if this requires combining both single-word and multi-word tags."
                                },
                                "summary": {
                                    "type": "string",
                                    "description": "Summary of the information about the customer website based on provided information. 3-6 sentences, 40-60 words."
                                },
                                "vertical": {
                                    "type": "string",
                                    "description": "Most relevant industry field of the website based on the provided info in your own opinion, no more than 3 words."
                                },
                                "style": {
                                    "type": "string",
                                    "description": "The most appropriate style bucket for the website from the list: Playful, Modern, Professional, Bold, Classic."
                                },
                                "websiteSections": {
                                    "type": "array",
                                    "description": "Return ALL of the following sections: Contact Form, Testimonials, Appointments. The order of the sections must be dynamically determined based on metadata relevance.",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "websiteFeatures": {
                                    "type": "array",
                                    "description": "Return ALL of the following features: Store, Appointments, Blog. The order of the features must be dynamically determined based on metadata relevance.",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "blocks": {
                                    "type": "object",
                                    "properties": {
                                        "cover": {
                                            "type": "object",
                                            "properties": {
                                                "title": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual title content for the cover."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the title content.",
                                                            "default": 6
                                                        }
                                                    },
                                                    "description": "A creative and engaging cover title for the website, that uses the full 6 word maximum. This title should encapsulate the business's purpose or unique selling point, avoiding repetitive use of just the Business name unless explicitly relevant."
                                                },
                                                "button1text": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual text for the first button."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the first button text.",
                                                            "default": 4
                                                        }
                                                    },
                                                    "description": "Call-to-action text for the first button on the cover, with a maximum of 4 words. This should inspire user interaction, such as 'Learn More' or 'Shop Now.'"
                                                },
                                                "button2text": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual text for the second button."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the second button text.",
                                                            "default": 4
                                                        }
                                                    },
                                                    "description": "Call-to-action text for the second button on the cover, with a maximum of 4 words. Complementary to the first button, it should provide an alternative action, such as 'Contact Us' or 'See Gallery.'"
                                                },
                                                "shortDescription": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual short description content."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the short description.",
                                                            "default": 10
                                                        }
                                                    },
                                                    "description": "A concise yet compelling short description for the cover section, with a maximum of 10 words. This should summarize the business's value proposition or core mission in a clear and appealing way while trying to use up the word maximum. Should never end with punctuation."
                                                },
                                                "subtitle": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual subtitle content."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the subtitle.",
                                                            "default": 5
                                                        }
                                                    },
                                                    "description": "A supporting subtitle with a maximum of 5 words. This should enhance the cover title by adding context or emphasizing the business's unique qualities."
                                                }
                                            }
                                        },
                                        "features": {
                                            "type": "object",
                                            "properties": {
                                                "featuretagline1": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual tagline content for the first feature."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the first feature tagline.",
                                                            "default": 5
                                                        }
                                                    },
                                                    "description": "An attention-grabbing tagline for the first feature, with a maximum of 5 words. Highlight a key aspect of the business, such as a product benefit or service strength."
                                                },
                                                "featuretagline2": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual tagline content for the second feature."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the second feature tagline.",
                                                            "default": 5
                                                        }
                                                    },
                                                    "description": "An attention-grabbing tagline for the second feature, with a maximum of 5 words. Complement the first tagline with another important business highlight."
                                                }
                                            }
                                        },
                                        "header": {
                                            "type": "object",
                                            "properties": {
                                                "title": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string",
                                                            "description": "The actual header title content."
                                                        },
                                                        "maxOutputTokens": {
                                                            "type": "integer",
                                                            "description": "The maximum number of tokens allowed for the header title.",
                                                            "default": 5
                                                        }
                                                    },
                                                    "description": "A strong and descriptive header title, with a maximum of 5 words. This should immediately convey the website's purpose and entice users to explore further."
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                ],
                "functionCall": {
                    "name": "template_selection"
                },
                "Model": "gpt-4o-mini"
        },
            "metaData": {
            "businessName": title,
            "category": category,
            "goal": prompt
        }
    }
}
